import { Card, Text } from "@overmap-ai/blocks"
import { type AssetTypeIdentifierValue, type Stored } from "@overmap-ai/common"
import { selectAssetTypeIdentifierById, selectUserById } from "@overmap-ai/core"
import { memo } from "react"

import { AssetTimelineItemType } from "../../enums/assets"
import { assetTimelineItemTypeData } from "../../mappings/assets"
import { useAppSelector } from "../../store"
import { formatCompactDate } from "../../utils/date"
import { getUserDisplayLabel } from "../../utils/users"
import { TimelineIconRail } from "../TimelineIconRail/TimelineIconRail"
import type { AssetTimelineSize } from "./typings"

interface AssetIdentifierValueTimelineItemProps {
	assetTypeIdentifierValue: Stored<AssetTypeIdentifierValue>
	size: AssetTimelineSize
}

export const AssetIdentifierValueTimelineItem = memo<AssetIdentifierValueTimelineItemProps>((props) => {
	const { assetTypeIdentifierValue, size } = props

	const createdBy = useAppSelector(selectUserById(assetTypeIdentifierValue.created_by ?? -1))
	const identifier = useAppSelector(selectAssetTypeIdentifierById(assetTypeIdentifierValue.asset_type_identifier))!

	const { icon } = assetTimelineItemTypeData[AssetTimelineItemType.IDENTIFIER_VALUE]

	return (
		<div className="flex h-max w-full gap-4">
			<TimelineIconRail icon={icon} size={size} />
			<Card className="flex min-w-0 grow flex-col gap-1" size={size}>
				<Text size={size} accentColor="base">
					<Text highContrast>{getUserDisplayLabel(createdBy)}</Text>
					&nbsp;updated identifier
					<Text accentColor="base">
						&nbsp;&#8226;&nbsp;{formatCompactDate(assetTypeIdentifierValue.submitted_at)}
					</Text>
				</Text>
				<Text accentColor="base" className="min-w-0 truncate" size={size}>
					<Text highContrast>{identifier.name}</Text>
					&nbsp;to&nbsp;
					<Text highContrast>{assetTypeIdentifierValue.value}</Text>
				</Text>
			</Card>
		</div>
	)
})
AssetIdentifierValueTimelineItem.displayName = "AssetIdentifierValueTimelineItem"
